import type React from "react";
import type { DateRange } from "react-day-picker";

import { Calendar } from "src/primitives/Calendar";

interface RangeCalendarProps {
  todayDate: Date;
  weekStartsOn: 0 | 1 | 2 | 3 | 4 | 5 | 6;
  month: Date;
  onMonthChange: (date: Date) => void;
  selected: DateRange | undefined;
  onSelect: (range: DateRange | undefined, triggerDate: Date) => void;
  disabled: (date: Date) => boolean;
  fromDate?: Date;
  toDate?: Date;
  onHoverIn: (e: React.MouseEvent<HTMLElement>) => void;
  onHoverOut: () => void;
  numberOfMonths?: number;
}

export const RangeCalendar = ({
  todayDate,
  weekStartsOn,
  month,
  onMonthChange,
  selected,
  onSelect,
  disabled,
  fromDate,
  toDate,
  onHoverIn,
  onHoverOut,
  numberOfMonths = 2,
}: RangeCalendarProps) => (
  <div onMouseOver={onHoverIn} onMouseLeave={onHoverOut}>
    <Calendar
      mode="range"
      numberOfMonths={numberOfMonths}
      captionLayout="dropdown"
      today={todayDate}
      weekStartsOn={weekStartsOn}
      className="[&_[data-outside][data-selected=true]]:!bg-transparent [&_[data-outside][data-selected=true]]:after:!bg-transparent [&_[data-outside]_button]:!bg-transparent [&_[data-outside]_button]:!text-muted-foreground"
      month={month}
      onMonthChange={onMonthChange}
      selected={selected}
      onSelect={onSelect}
      disabled={disabled}
      {...(fromDate && { fromDate })}
      {...(toDate && { toDate })}
    />
  </div>
);
